// extracted by mini-css-extract-plugin
export default {"container":"table_container__7cH--","header":"table_header__ltZzn","row":"table_row__drjm5","indent":"table_indent__hW0Qs","img-container":"table_img-container__Jdhjt"};